import { AccessControl } from '../../../AccessControl/AccessControl';
import { Button, Flexbox, Icon, Tooltip, Typography } from '@hiiretail/synergy-ui';
import React from 'react';
import { AccessDeniedButton } from '../../../../styles/AccessDenied.styles';

export type RefreshButtonProps = {
  onClick: () => void;
  permission: string;
};

export type RefreshButtonComponent = React.FC<RefreshButtonProps>;

export const RefreshButton: RefreshButtonComponent = ({ onClick, permission }) => {
  return (
    <AccessControl
      permission={permission}
      renderIfNoAccess={
        <Tooltip
          title={
            <Flexbox container direction="column">
              <Typography variant="caption" color={() => 'white'}>
                You do not have permissions to perform this action.
              </Typography>
              <Typography variant="caption" color={() => 'white'}>
                Required permissions: {/*@ts-ignore*/}
                <Typography variant="caption" weight="bold" color={() => 'white'}>
                  {permission}
                </Typography>
              </Typography>
            </Flexbox>
          }
        >
          <AccessDeniedButton disabled variant="icon" data-testid="refresh-entity-button">
            <Icon.Rotate color={() => '#eeeeee'} />
          </AccessDeniedButton>
        </Tooltip>
      }
    >
      <Button variant="icon" data-testid="refresh-entity-button" onClick={onClick}>
        <Icon.Rotate />
      </Button>
    </AccessControl>
  );
};
